<template>
  <catalog-product-single style="margin-top: 10px" :loading="loading" :item="item" />
</template>

<script>
import CatalogProductSingle from './CatalogProductSingle';

export default {
  name: 'CatalogProductSingleContainer',
  components: {
    CatalogProductSingle,
  },
  computed: {
    item() {
      return this.$store.state.catalog.item;
    },
    loading() {
      return this.$store.state.catalog.itemLoading;
    },
  },
  mounted() {
    this.$store.dispatch('catalog/fetchProduct', this.$route.params.id);
  },

};
</script>

<style lang="scss" scoped>

</style>
